import { useEffect, useState } from 'react';
import Inputs from './components/Inputs';
import GridProvider from './components/GridProvider';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import Spinner from '../../UI/Modal/Spinner';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import toast from 'react-hot-toast';
import MyButton from '../../UI/myButton/MyButton';

const INITIAL_VALUES = {
  id: 0,
  korisnickoIme: '',
  lozinka: '',
  idMenija: null,
  trajanjeTokena: null,
  idKorProm: null,
  ime: '',
  prezime: '',
  email: '',
  kontaktTelefon: '',
  napomena: '',
  tehnickoLice: false,
  administrator: false,
  kontaktOsoba: false,
  lista: [],
  idKupca: null,
  nazivKupca: '',
  idZaposlenog: null,
  imeZaposlenog: '',
  ucestvujeUChatu: false,
};
const KorisniciPrograma = ({
  save,
  handleSave,
  novi,
  handleNovi,
  idKlijenta = null,
  klijent = '',
}) => {
  const idFirme = idKlijenta !== null ? idKlijenta : +localStorage.idFirme;
  const jeInmold = +idFirme === 1;
  const { t, i18n } = useTranslation();
  const { sendRequest, getData, data, isLoading } = useHttp('');
  // const { sendRequest: vratiKupce, data: korisniciData } = useHttp('');

  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const { sendRequest: vratiTipMasine, data: tipMasineData } = useHttp('');
  const { sendRequest: vratiMenije, data: menijiData } = useHttp('');

  const vratiKorisnikePrograma = () => {
    const config = {
      method: 'POST',
      url: urls.GET_KORISNICI_PROGRAMA,
      data: { id: idFirme, metadata: i18n.language },
    };
    sendRequest(config);
  };

  useEffect(() => {
    // fetchKupciData();
    vratiKorisnikePrograma();
    const configTipMasine = {
      url: urls.GET_TIPOVI_MASINA,
      method: 'POST',
      data: { metadata: i18n.language },
    };
    vratiTipMasine(configTipMasine);
  }, [i18n.language]);

  useEffect(() => {
    if (jeInmold) {
      vratiMenije({ url: urls.GET_MENIJI_INMOLD });
    }
  }, [jeInmold]);

  const handleSaveData = async () => {
    if (jeInmold && !formValues.idMenija) {
      setFormValues((curr) => {
        return { ...curr, touchedMeni: true };
      });
      toast.error(t('meniObavezan'));
      return;
    }
    const config = {
      method: 'POST',
      url: formValues.id !== 0 ? urls.UPDATE_KORISNIK : urls.INSERT_KORISNIK,
      data: {
        ...formValues,
        idKupca: idFirme,
        idKorProm: +localStorage.idKorisnika,
        idMenija: 1,
        trajanjeTokena: 28800,
        lista: formValues.lista || formValues.listaTipovaMasine,
      },
    };
    const result = await getData(config);
    if (result.id > 0) {
      const dodelaMenija = jeInmold
        ? await getData({
            method: 'POST',
            url: urls.DODELA_MENIJA_INMOLD,
            data: {
              id: result.id,
              idMenija: formValues.idMenija,
              idKorProm: +localStorage.idKorisnika,
            },
          })
        : null;
      vratiKorisnikePrograma();
      setFormValues(INITIAL_VALUES);
      if (jeInmold && dodelaMenija?.rezultat !== 1) {
        toast.error(t('greskaDodelaMenija'));
        return;
      }
      toast.success(
        formValues.id === 0
          ? t('userDataSavedSuccessfully')
          : t('userDataUpdatedSuccessfully'),
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);
  const handleNoviUnos = () => {
    setFormValues(INITIAL_VALUES);
  };
  useEffect(() => {
    if (novi) {
      handleNoviUnos();
      handleNovi(false);
    }
  }, [novi]);

  const handleOpenDeleteDialog = (id) => {
    setFormValues((curr) => {
      return { ...curr, id: id };
    });
    setOpenDeleteDialog(true);
  };
  const handleCloseDelete = () => {
    setFormValues(INITIAL_VALUES);
    setOpenDeleteDialog(false);
  };
  const handleEditData = async (id) => {
    const config = {
      method: 'POST',
      url: urls.GET_KORISNIK_ZA_ID,
      data: { id: id, metadata: i18n.language },
    };
    const response = await getData(config);
    if (response.id > 0) {
      // console.log('edit ', response);
      setFormValues(response);
    }
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_KORISNIK,
      data: { id: formValues.id },
    };
    const response = await getData(config);
    if (response > 0) {
      toast.success(t('dataSuccessfullyDeleted'));
      setFormValues(INITIAL_VALUES);
      setOpenDeleteDialog(false);
      vratiKorisnikePrograma();
      return;
    }
    toast.error('errorDeletingData');
  };
  return (
    <div>
      {isLoading && <Spinner />}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Inputs
          formValues={formValues}
          setFormValues={setFormValues}
          // korisniciData={korisniciData}
          tipMasineData={tipMasineData}
          idKlijenta={idKlijenta}
          klijent={klijent}
          jeInmold={jeInmold}
          menijiData={menijiData}
        />
        {idKlijenta && (
          <div>
            <MyButton label="Sačuvaj korisnika" onClick={handleSaveData} />
            <MyButton label="Novi korisnik" onClick={handleNoviUnos} />
          </div>
        )}
      </div>

      <GridProvider
        data={data}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleEditData={handleEditData}
        isLoading={isLoading}
        idKlijenta={idKlijenta}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default KorisniciPrograma;
